
import { Component, Prop, Vue } from "vue-property-decorator";
import anime from "animejs";

@Component
export default class MenuHome extends Vue {

  isMobile() {
      if( screen.width <= 760 ) {
          return true;
      }
      else {
          return false;
      }
  }

  mounted() {
    anime({
      targets: [".item"],
      translateX: 1200,
      duration: 1000,
      direction: 'reverse',
      color: 'rgba(0, 0, 0, 0)',
      easing: 'easeInOutSine',
      delay: 2000
    });
  }
}
